import styled from "styled-components";

export const WidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SplashTitle = styled.h1`
  font-family: "Georgia";
  font-weight: 400;
  margin-bottom: 16px;
  font-size: 42px;
  color: white;
`;
